<ng-container [formGroup]="form">
    <!-- Campo escondido: ajuda o gerenciador de senhas a associar a senha ao e-mail -->
    <input type="text" class="hidden-username" tabindex="-1" aria-hidden="true" autocomplete="username" [value]="email">

    <!-- Um único usuário: só a senha -->
    <ng-container *ngIf="!mostrarOpcoes; else escolherLogin">
        <ng-container *ngTemplateOutlet="campoSenha; context: {
            classe: 'full-input-grid senha',
            dataTestCampoSenha: 'campo-senha-login',
            dataTestOlho: 'icone-visualizar-senha',
            dataTestDivSenha: 'div-campo-senha'
        }"></ng-container>
    </ng-container>

    <!-- Vários usuários: Administrador (senha logo abaixo) ou usuário (usuário e senha abaixo dos dois) -->
    <ng-template #escolherLogin>
        <mat-radio-group formControlName="authMode" class="auth-mode-group">
            <mat-radio-button data-test="radio-entrar-como-administrador" value="admin" color="primary" class="auth-radio">{{ 'signIn.enterAsAdministrator' | translate }}</mat-radio-button>

            <ng-container *ngIf="!pedeUsuario">
                <ng-container *ngTemplateOutlet="campoSenha; context: {
                    classe: 'password-input-group senha',
                    dataTestCampoSenha: 'campo-senha-escolha-login-admin',
                    dataTestOlho: 'icone-visualizar-senha-escolha-login-admin'
                }"></ng-container>
            </ng-container>

            <mat-radio-button data-test="radio-entrar-como-usuario" value="user" color="primary" class="auth-radio">{{ 'signIn.enterAsUser' | translate }}</mat-radio-button>

            <ng-container *ngIf="pedeUsuario">
                <mat-form-field class="password-input-group" appearance="outline">
                    <mat-label>{{ 'signUp.user' | translate }}</mat-label>
                    <input #userNameInput data-test="campo-usuario-escolha-login" type="text" matInput formControlName="user"
                        placeholder="Ex: joao.silva" autocomplete="username" appLowercaseNoSpaces>
                    <mat-icon matPrefix>perm_identity_icon</mat-icon>
                    <mat-error *ngIf="campos['user'].invalid">{{ message.errorMessage(campos['user']) }}</mat-error>
                </mat-form-field>

                <ng-container *ngTemplateOutlet="campoSenha; context: {
                    classe: 'password-input-group senha',
                    dataTestCampoSenha: 'campo-senha-escolha-login-usuario',
                    dataTestOlho: 'icone-visualizar-senha-escolha-login-usuario'
                }"></ng-container>
            </ng-container>
        </mat-radio-group>
    </ng-template>

    <!-- Campo de senha reaproveitado nos três lugares em que aparece -->
    <ng-template #campoSenha let-classe="classe" let-dataTestCampoSenha="dataTestCampoSenha" let-dataTestOlho="dataTestOlho"
        let-dataTestDivSenha="dataTestDivSenha">
        <mat-form-field appearance="outline" [ngClass]="classe" [attr.data-test]="dataTestDivSenha || null">
            <mat-label>{{ 'signUp.password' | translate }}</mat-label>
            <input #passwordInput appCapsLockWarning #caps="capsLockWarning" [attr.data-test]="dataTestCampoSenha" [type]="hide ? 'password' : 'text'" matInput formControlName="password"
                maxlength="30" autocomplete="current-password" (blur)="campos['password'].markAsTouched()"
                (paste)="$event.preventDefault()" (copy)="$event.preventDefault()"
                (cut)="$event.preventDefault()" (drop)="$event.preventDefault()">
            <button type="button" mat-icon-button color="primary" matSuffix (click)="hide = !hide"
                [attr.aria-label]="'signIn.showPassword' | translate" [attr.data-test]="dataTestOlho">
                <mat-icon>{{ hide ? 'visibility_off' : 'visibility' }}</mat-icon>
            </button>
            <mat-icon matPrefix>lock</mat-icon>
            <mat-hint *ngIf="caps.ativo" class="caps-lock-hint" data-test="aviso-caps-lock">{{ 'signIn.capsLockOn' | translate }}</mat-hint>
            <mat-error *ngIf="campos['password'].invalid && campos['password'].touched && campos['password'].dirty">{{ message.errorMessage(campos['password']) }}</mat-error>
        </mat-form-field>
    </ng-template>
</ng-container>
